import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  FacilityShiftsCalendarDto,
  FacilityShiftsCalendarParams
} from '../../models/facilities/facility-shifts.model';

@Injectable({
  providedIn: 'root'
})
export class FacilityShiftsService {
  private readonly http = inject(HttpClient);

  getCalendar(
    id: string,
    params?: FacilityShiftsCalendarParams
  ): Observable<FacilityShiftsCalendarDto> {
    const httpParams = HttpHelper.toHttpParams(params);
    return this.http.get<FacilityShiftsCalendarDto>(
      `/api/facilities/${id}/shifts/calendar`,
      {
        params: httpParams
      }
    );
  }
}
